import React from 'react';

const ChatPreview = (props) => {
    const { title, description, image_url } = props;

    return (
        <div className="card hover:scale-105 transition ease-in-out delay-50 w-72 m-10 bg-base-100 shadow-xl relative">
            <figure className="px-1 pt-1">
                <div className="relative h-48 w-full">
                    <img
                        className="inset-0 m-1 h-full w-full object-contain object-center"
                        src={image_url}
                        alt="Chat Preview"
                    />
                </div>
            </figure>
            <div className="card-body items-center text-center">
                <h2 className="card-title text-md">{title}</h2>
                <p>{description}</p>
            </div>
        </div>
    );
};

export default ChatPreview;
